export const artProjects = [
  {
      listTitle: "single panel",
      tags: ['all', 'illustration'],
      samples: [
        {
          title: "Skyscraper Pinata",
          image: "/assets/nyer/SkyscraperPinata.webp",
        },
        {
          title: "Bakeoff Boxer",
          image: "/assets/nyer/BakeoffBoxer.webp",
        },
        {
          title: "Millenial Weight Blanket",
          image: "/assets/nyer/MillenialWeightBlanket.webp",
        },
        {
          title: "Cat Sovereignty",
          image: "/assets/nyer/Cat_Sovereignty.webp",
        },
         {
          title: "That Pontiac",
          image: "/assets/nyer/ThatPontiac.webp",
        },
        {
          title: "See Other People",
          image: "/assets/nyer/See_Other_People.webp",
        },
         {
          title: "Spider Lawyer",
          image: "/assets/nyer/SpiderLawyer.webp",
        },
        {
          title: "Swipe Face",
          image: "/assets/nyer/SwipeFace.webp",
        },
        {
          title: "Ant Waiter",
          image: "/assets/nyer/AntWaiter.webp",
        },
        {
          title: "Good Enough",
          image: "/assets/nyer/GoodEnough.webp",
        },
        {
          title: "Hiding from News",
          image: "/assets/nyer/Hiding_From_News.webp",
        },
        {
          title: "Handgun",
          image: "/assets/nyer/Handgun.webp",
        },
        {
          title: "Kevin Instantcashoffer",
          image: "/assets/nyer/Kevin_Instantcashoffer.webp",
        },
        {
          title: "Finest Condiments",
          image: "/assets/nyer/Finest_Condiments.webp",
        },
        {
          title: "Frost the Delayed Snowman",
          image: "/assets/nyer/Frosty_The_Delayed_Snowman.webp",
        },
        {
          title: "Gift Wave",
          image: "/assets/nyer/Gift_Wave.webp",
        },
        {
          title: "Human Shoes",
          image: "/assets/nyer/Human_Shoes.webp",
        },
        {
          title: "Mr Owl In Billing",
          image: "/assets/nyer/Mr Owl In Billing.webp",
        },
        {
          title: "How's Waldo",
          image: "/assets/nyer/How's_Waldo.webp",
        },
        {
          title: "Prince of Darkness Yoga",
          image: "/assets/nyer/Prince_Of_Darkness_Yoga.webp",
        },
        {
          title: "Devastating Ex",
          image: "/assets/nyer/Devastating_Ex.webp",
        },
        {
          title: "Screwed Wine Bottles",
          image: "/assets/nyer/Screwed.webp",
        },
        {
          title: "State of the Art Care",
          image: "/assets/nyer/State_Of_The_Art_Care.webp",
        },
        {
          title: "Really No Gifts",
          image: "/assets/nyer/Really No Gifts.webp",
        },
        {
          title: "Rigoletto Heist",
          image: "/assets/nyer/Rigoletto_Heist.webp",
        },
        {
          title: "Goodbye Failure",
          image: "/assets/nyer/Goodbye_Hello.webp",
        },
        {
          title: "Siege Diet",
          image: "/assets/nyer/Siege_Diet.webp",
        },
        {
          title: "Mediocre",
          image: "/assets/nyer/Mediocre.webp",
        },
        {
          title: "Cowlick Dracula",
          image: "/assets/nyer/CowlickDracula.webp",
        },
        {
          title: "Critical Bogeyman",
          image: "/assets/nyer/CriticalBogeyman.webp",
        },
        {
          title: "Goldfish Memory",
          image: "/assets/nyer/Goldfish_Memory.webp",
        },
        {
          title: "Lets Never",
          image: "/assets/nyer/LetsNever.webp",
        },
        {
          title: "Metal Todds Dad",
          image: "/assets/nyer/MetalToddsDad.webp",
        },
        {
          title: "Plain Vanilla",
          image: "/assets/nyer/PlainVanilla.webp",
        },
        {
          title: "Soul Pets",
          image: "/assets/nyer/SoulPets.webp",
        },
        {
          title: "Microplastics",
          image: "/assets/nyer/Microplastics.webp",
        },
        {
          title: "Lady of the Lake",
          image: "/assets/nyer/LadyOfTheLake.webp",
        },
        {
          title: "Curriculum Inhibitor",
          image: "/assets/nyer/CurriculumInhibitor.webp",
        },
        {
          title: "Frankensteins Provider",
          image: "/assets/nyer/FrankensteinsProvider.webp",
        },
        {
          title: "Community Chest",
          image: "/assets/nyer/CommunityChest.webp",
        },
        {
          title: "Uncle Sam Overlords",
          image: "/assets/nyer/UncleSamOverlords.webp",
        },
        {
          title: "Victim Vacation",
          image: "/assets/nyer/VictimVacation.webp",
        },
        {
          title: "Werewolf Haircut",
          image: "/assets/nyer/WerewolfHaircut.webp",
        },
        {
          title: "You Were Saying",
          image: "/assets/nyer/YouWereSaying.webp",
        },
        {
          title: "Metal Parenting",
          image: "/assets/nyer/MetalParenting.webp",
        },
        {
          title: "Bond Astigmatism",
          image: "/assets/nyer/BondAstigmatism.webp",
        },
      ]
  },
  {
      listTitle: "dnd comics",
      tags: ['all', 'illustration', 'dnd'],
      samples: [
        {
          title: "Speak with Dead",
          image: "/assets/dndcomics/Speak_With_Dead.webp",
        },
        {
          title: "Find Familiar",
          image: "/assets/dndcomics/Find_Familiar.webp",
        },
        {
          title: "Gristle, the Ornery Goblin NPC",
          image: "/assets/dndcomics/Gristle.webp",
        },
        {
          title: "Kobold Chefs Mary and Barry",
          image: "/assets/dndcomics/Mary_And_Barry.webp",
        },
        {
          title: "Mayor Morris NPC",
          image: "/assets/dndcomics/Mayor_Morris.webp",
        },
        {
          title: "Animal Friendship",
          image: "/assets/dndcomics/AnimalFriendship.webp",
        },
        {
          title: "Hunters Mark Meeting",
          image: "/assets/dndcomics/HuntersMarkMeeting.webp",
        },
        {
          title: "Lesser Restoration Weekend",
          image: "/assets/dndcomics/LessRestorationWeekend.webp",
        },
        {
          title: "Mage Hand Dad",
          image: "/assets/dndcomics/MageHandDad.webp",
        },
        {
          title: "Persuasion Check Interview",
          image: "/assets/dndcomics/PersuasionCheckInterview.webp",
        },
        {
          title: "Toddler Identify",
          image: "/assets/dndcomics/ToddlerIdentify.webp",
        },
        {
          title: "Cyclops Constable",
          image: "/assets/dndcomics/Constable_Clavin.webp",
        },
        {
          title: "Masquerade Invitation",
          image: "/assets/dndcomics/Masquerade_Invitation.webp",
        },
        {
          title: "Kristen and Harold",
          image: "/assets/dndcomics/Kristen_And_Harold.webp",
        },
        {
          title: "Dancing Skeletons",
          image: "/assets/dndcomics/Dancing_Skeletons.webp",
        },
        {
          title: "Early, the Hooch-Addicted Tadpole NPC",
          image: "/assets/dndcomics/Early.webp",
        },
        {
          title: "Krampus NPC",
          image: "/assets/dndcomics/Krampus.webp",
        },
        {
          title: "Undarya Cover",
          image: "/assets/dndcomics/Undarya_Cover.webp",
        },
      ]
  },
  {
    listTitle: "collabs with my kiddos",
    tags: ['all', 'collabs', 'illustration'],
    samples: [
      {
        title: "Shark Velociraptor Flamingo",
        image: "/assets/kidmonsters/Boyabutt.jpg",
      },
      {
        title: "Banjo-Playing Frog Scorpion Turtle",
        image: "/assets/kidmonsters/Goldon.jpg",
      },
      {
        title: "Banjo-Playing Shark Crab Squirrel",
        image: "/assets/kidmonsters/Sharky.jpg",
      },
      {
        title: "Banjo-Playing Goose Flamingo Ostrich",
        image: "/assets/kidmonsters/Boa.jpg",
      },
      {
        title: "Banjo-Playing Turtle Raptor Ostrich",
        image: "/assets/kidmonsters/Champ.jpg",
      },
      {
        title: "Octopus Guitar Player",
        image: "/assets/kidmonsters/Rock_Star.webp",
      },
      {
        title: "Lizard Monster Truck",
        image: "/assets/kidmonsters/Dumpstern.jpg",
      },
      {
        title: "Shark Monster",
        image: "/assets/kidmonsters/Crycry.jpg",
      },
      {
        title: "Axolotl Owl",
        image: "/assets/kidmonsters/Mew.jpg",
      },
      {
        title: "Robot Chameleon",
        image: "/assets/kidmonsters/Niang_The_Robot_Chameleon.jpg",
      },
      {
        title: "Chameleon Hydra",
        image: "/assets/kidmonsters/Rainbowspike.jpg",
      },
      {
        title: "Axolotl Bat Turtle",
        image: "/assets/kidmonsters/Swingtaker.jpg",
      },
      {
        title: "Croc Horse",
        image: "/assets/kidmonsters/Juhjuh_Baby.jpg",
      },
      {
        title: "Snake Turtle Scorpion",
        image: "/assets/kidmonsters/Mryken.jpg",
      },
      {
        title: "Pterodactyl Crab Ostrich Scorpion",
        image: "/assets/kidmonsters/Gainey.jpg",
      },
      {
        title: "Slug Raccoon Frog",
        image: "/assets/kidmonsters/Raimbowt.jpg",
      },
      {
        title: "Shark Chameleon",
        image: "/assets/kidmonsters/Sharkfeen.jpg",
      },
      {
        title: "Basilisk, Anaconda, and Piranhas",
        image: "/assets/kidmonsters/Lightfrill_&_Basey.jpg",
      },
      {
        title: "Gryphon Bat Scorpion",
        image: "/assets/kidmonsters/Noah_Lizardbammer.jpg",
      },
      {
        title: "Brontosaurus Butterfly Alligator",
        image: "/assets/kidmonsters/Piopi_.jpg",
      },
      {
        title: "Axolotl Oxen Dragonfly",
        image: "/assets/kidmonsters/Stunkoo.webp",
      },
      {
        title: "Minecraft Angel",
        image: "/assets/kidmonsters/Minecraft_Angel.webp",
      },
    ]
  },
  {
      listTitle: "fan art",
      tags: ['all', 'fanart', 'illustration'],
      samples: [
        {
          title: "Greninja Runway",
          image: "/assets/fanart/GreninjaRunway.png",
        },
        {
          title: "Pikachu Garage",
          image: "/assets/fanart/PikachuGarage.png",
        },
        {
          title: "Pinocchio and Minerva",
          image: "/assets/fanart/Pinocchio_And_Minerva.webp",
        },
        {
          title: "Kei and Yuri",
          image: "/assets/fanart/Dirty_Pair.webp",
        },
        {
          title: "Adam Strange",
          image: "/assets/fanart/Adam_Strange.webp",
        },
        {
          title: "Dover Boys Skipper",
          image: "/assets/fanart/Dover_Boys.webp",
        },
        {
          title: "Pokemon TV",
          image: "/assets/fanart/Pokemon_TV.jpg",
        },
        {
          title: "Pokemon Museum",
          image: "/assets/fanart/PokeMuseum.JPG",
        },
        {
          title: "Pokemon House",
          image: "/assets/fanart/PokeHouse.jpg",
        },
        {
          title: "Yusuke Urameshi",
          image: "/assets/fanart/Urameshi.jpg",
        },
        {
          title: "Kazuma Kuwabara",
          image: "/assets/fanart/Kuwabara.JPG",
        },
        {
          title: "Sesshomaru",
          image: "/assets/fanart/Seshomaru.webp",
        },
        {
          title: "Action Kamen",
          image: "/assets/fanart/Action_Bastard.jpg",
        },
        {
          title: "MGM Tom and the Mouseketeer",
          image: "/assets/fanart/Mouseketeers.JPG",
        },
        {
          title: "Wile E Coyote and Roadrunner",
          image: "/assets/fanart/Coyote_&_Roadrunner.JPG",
        },
        {
          title: "One Piece Straw Hat Crew",
          image: "/assets/fanart/OnePiece.JPG",
        },
        {
          title: "Ms. Leficent",
          image: "/assets/fanart/Ms_Leficent.jpg",
        },
        {
          title: "Duck Tales Crash",
          image: "/assets/fanart/Duck_Tales_Crash.jpg",
        },
         {
          title: "Gatchaman",
          image: "/assets/fanart/Gatchaman.JPG",
        },
        {
          title: "Spider-Man Web Sauce",
          image: "/assets/fanart/Web_Sauce.JPG",
        },
        {
          title: "Bizarro",
          image: "/assets/fanart/Bizarro.webp",
        },
        {
          title: "Kirby's Ben Grimm",
          image: "/assets/fanart/Ben_Grimm.webp",
        },
        // {
        //   title: "NSync Family Guy Album Cover",
        //   image: "/assets/fanart/NoStrings.jpg",
        // },
      ]
  },
  {
      listTitle: "miscellany",
      tags: ['all', 'illustration'],
      samples: [
        {
          title: "Woodland Happy Hour Flyer",
          image: "/assets/miscellany/Comm_Happy_Hour.webp",
        },
        {
          title: "Dancing Bugs Happy Hour Flyer",
          image: "/assets/miscellany/Dancing_Bugs.webp",
        },
        {
          title: "Dogs in Glasses Happy Hour Flyer",
          image: "/assets/miscellany/Dogs_In_Glasses.webp",
        },
        {
          title: "Space Party Happy Hour Flyer",
          image: "/assets/miscellany/Space_Party.webp",
        },
        {
          title: "Fiddle Fox",
          image: "/assets/miscellany/Fiddle_Fox.webp",
        },
        {
          title: "Chicken Robot",
          image: "/assets/miscellany/Chicken_Robot.webp",
        },
        {
          title: "Kaiju Fun",
          image: "/assets/miscellany/Kaiju_Fun1.webp",
        },
        {
          title: "Dog in Space",
          image: "/assets/miscellany/Dog_In_Space.webp",
        },
        {
          title: "Rassler",
          image: "/assets/miscellany/Rassler.webp",
        },
        {
          title: "Artbot",
          image: "/assets/miscellany/Artbot.webp",
        },
        {
          title: "COGStm",
          image: "/assets/miscellany/COGStm.webp",
        },
        {
          title: "October",
          image: "/assets/miscellany/October_Design.webp",
        },
        {
          title: "Can'ta Claus",
          image: "/assets/miscellany/Canta_Claus.webp",
        },
        {
          title: "Thing Pumpkin",
          image: "/assets/miscellany/Thing_Pumpkin.webp",
        },
        {
          title: "Calvin and Hobbes Masks",
          image: "/assets/miscellany/Calvin_Hobbes_Heads.webp",
        },
        {
          title: "Paper Dalek",
          image: "/assets/miscellany/Dalek.webp",
        },
        {
          title: "Flying Leap",
          image: "/assets/miscellany/Flying_Leap.webp",
        },
        {
          title: "Dog Pianist",
          image: "/assets/miscellany/Dog_Pianist.webp",
        },
        {
          title: "Typeotter",
          image: "/assets/miscellany/Typeotter.webp",
        },
      ]
  },
  {
      listTitle: "graphite",
      tags: ['all', 'illustration'],
      samples: [
        {
          title: "Portrait Profile Linework",
          image: "/assets/graphite/PortraitProfileLine.jpg",
        },
        {
          title: "Portrait Profile Values",
          image: "/assets/graphite/PortraitProfile.jpg",
        },
        {
          title: "Still Life Value Study",
          image: "/assets/graphite/StillLifeValueStudy.jpg",
        },
        {
          title: "Lego Chicken Figure",
          image: "/assets/graphite/LegoValueStudy.jpg",
        },
        {
          title: "Roober Portrait",
          image: "/assets/graphite/Roober_3-4.jpg",
        },
      ]
  },
  {
      listTitle: "webcomic: it came from hugo pines!",
      tags: ['all', 'illustration'],
      samples: [
         {
          title: "Main Character Bios",
          image: "/assets/hugopines/ICFHP_bios.PNG",
        },
        {
          title: "Face Lineup",
          image: "/assets/hugopines/HPlineup.JPG",
        },
        {
          title: "Customer is Always Sexy",
          image: "/assets/hugopines/Customer.webp",
        },
        {
          title: "Chapter 04",
          image: "/assets/hugopines/ICFHP_ch04.PNG",
        },
        {
          title: "Chapter 05",
          image: "/assets/hugopines/ICFHP_ch05.PNG",
        },
        {
          title: "Chapter 06",
          image: "/assets/hugopines/ICFHP_ch06.PNG",
        },
        {
          title: "Chapter 08",
          image: "/assets/hugopines/ICFHP_ch08.PNG",
        },
        {
          title: "Chapter 09",
          image: "/assets/hugopines/ICFHP_ch09.PNG",
        },
        {
          title: "Chapter 10",
          image: "/assets/hugopines/ICFHP_ch10.PNG",
        },
        {
          title: "Chapter 11",
          image: "/assets/hugopines/ICFHP_ch11.PNG",
        },
        {
          title: "Chapter 12",
          image: "/assets/hugopines/ICFHP_ch12.PNG",
        },
        {
          title: "Chapter 14",
          image: "/assets/hugopines/ICFHP_ch14.PNG",
        },
        {
          title: "Chapter 36",
          image: "/assets/hugopines/ICFHP_ch36.PNG",
        },
        {
          title: "Chapter 37",
          image: "/assets/hugopines/ICFHP_ch37.PNG",
        },
        {
          title: "Chapter 38",
          image: "/assets/hugopines/ICFHP_ch38.PNG",
        },
        {
          title: "Chapter 39",
          image: "/assets/hugopines/ICFHP_ch39.PNG",
        },
        {
          title: "Chapter 40",
          image: "/assets/hugopines/ICFHP_ch40.PNG",
        },
        {
          title: "Chapter 41",
          image: "/assets/hugopines/ICFHP_ch41.PNG",
        },
        {
          title: "Chapter 42",
          image: "/assets/hugopines/ICFHP_ch42.PNG",
        },
         {
          title: "Chapter 43",
          image: "/assets/hugopines/ICFHP_ch43.PNG",
        },
        {
          title: "Chapter 44",
          image: "/assets/hugopines/ICFHP_ch44.PNG",
        },
        {
          title: "Chapter 45",
          image: "/assets/hugopines/ICFHP_ch45.PNG",
        },
        {
          title: "Chapter 46",
          image: "/assets/hugopines/ICFHP_ch46.PNG",
        },
      ]
  },
  {
      listTitle: "software dev & ui design",
      tags: ['all', 'software dev'],
      samples: [
        {
          title: "Vakay!",
          image: "/assets/UIwork/VakayUI.png",
        },
        {
          title: "Emotional Wellbeing Lab",
          image: "/assets/UIwork/ewb-lab-UI.png",
        },
        {
          title: "5e Monster Manual",
          image: "/assets/UIwork/MonsterManual-UI.png",
        },
        {
          title: "Doctor-Banjo",
          image: "/assets/UIwork/Doctor-Banjo.webp",
        },
        {
          title: "Subscriber",
          image: "/assets/UIwork/SubscriberUI.png",
        },
        {
          title: "ifGift",
          image: "/assets/UIwork/ifGiftUI.png",
        },
      ]
  },
  {
      listTitle: "logo design",
      tags: ['all', 'software dev'],
      samples: [
        {
          title: "Vakay!",
          image: "/assets/logos/VakayLogo.png",
        },
        {
          title: "Subscriber",
          image: "/assets/logos/SubscriberLogo.png",
        },
        {
          title: "ifGift",
          image: "/assets/logos/ifGiftLogo.png",
        },
      ]
  },
];


export const writingProjects = [
  {
    listTitle: "pilot scripting",
    tags: ['all', 'scriptwork', 'writing'],
    samples: [
      {
        title: "fantastic four spec pilot",
        image: "/assets/scripts/FFpilot.pdf",
      },
      {
        title: "the book was better",
        image: "/assets/scripts/BookWasBetter.pdf"
      },
      {
        title: "squatch and the city",
        image: "/assets/scripts/SquatchAndTheCity.pdf"
      },
      {
        title: "monsterology",
        image: "/assets/scripts/Monsterology.pdf"
      }
    ]
  },
  {
    listTitle: "comic spec scripting",
    tags: ['all', 'scriptwork', 'writing'],
    samples: [
      {
        title: "nessie frump, galactic local 918",
        image: "/assets/scripts/NessieFrump.pdf",
      },
      {
        title: "the red heresy",
        image: "/assets/scripts/TheRedHeresy.pdf",
      },
      {
        title: "in deep space",
        image: "/assets/scripts/InDeepSpace.pdf",
      },
      {
        title: "cleaning the attic",
        image: "/assets/scripts/CleaningTheAttic.pdf",
      },
      {
        title: "delays in parenting",
        image: "/assets/scripts/DelaysInParenting.pdf",
      },
      {
        title: "middle management",
        image: "/assets/scripts/MiddleManagement.pdf",
      },
    ]
  },
  {
    listTitle: "old sketch samples",
    tags: ['all', 'scriptwork', 'writing'],
    samples: [
      {
        title: "friendzone sketches",
        image: "/assets/scripts/FZsketches.pdf",
      },
      {
        title: "torture sketch",
        image: "/assets/scripts/TortureSketch.pdf"
      },
      {
        title: "in a relationship sketch",
        image: "/assets/scripts/InARelationshipSketch.pdf"
      },
      // {
      //   title: "daycare noir sketch",
      //   image: "/assets/scripts/DayCareNoirSketch.pdf"
      // },
    ]
  },
  {
    listTitle: "game show scripting",
    tags: ['all', 'scriptwork', 'writing'],
    samples: [
      {
        title: "slingtv multiplayer eps 5-6",
        image: "/assets/scripts/MULTIPLAYEReps5-6.pdf",
      },
      {
        title: "slingtv multiplayer eps 7-8",
        image: "/assets/scripts/MULTIPLAYEReps7-8.pdf",
      },
      {
        title: "slingtv multiplayer eps 9-10",
        image: "/assets/scripts/MULTIPLAYEReps9-10.pdf",
      },
    ]
  },
  {
    listTitle: "comic collaborations",
    tags: ['all', 'collabs', 'writing'],
    samples: [
      {
        title: "first in morale",
        image: "/assets/comiccollabs/FirstInMorale.pdf",
      },
      {
        title: "consequential",
        image: "/assets/comiccollabs/Consequential.pdf",
      },
      {
        title: "mr. monster, art by jess reilly",
        image: "/assets/comiccollabs/MrMonster.pdf",
      }
    ]
  }
];


export const linkProjects = [
  {
    listTitle: "animation scripting: lore in a minute",
    tags: ['all', 'writing', 'collabs'],
    samples: [
      {
        title: "forgotten realms lore video link",
        image: "/assets/anishorts/FRlore.webp",
        link: "https://www.youtube.com/watch?v=_MC--auSi-w"
      },
      {
        title: "futurama lore video link",
        image: "/assets/anishorts/FUTlore.webp",
        link: "https://www.youtube.com/watch?v=Sd1qz16fhwk&t=17s"
      },
      {
        title: "jojos bizarre adventure lore video link",
        image: "/assets/anishorts/JJBAlore.webp",
        link: "https://www.youtube.com/watch?v=v2wGZBjvcvo"
      },
      {
        title: "katamari damacy lore video link",
        image: "/assets/anishorts/KDlore.webp",
        link: "https://www.youtube.com/watch?v=RdkkSYqClyk"
      },
      {
        title: "mortal kombat x lore video link",
        image: "/assets/anishorts/MKXlore.webp",
        link: "https://www.youtube.com/watch?v=b052IbtKaKs"
      },
      {
        title: "mobile suit gundam lore video link",
        image: "/assets/anishorts/MSGlore.webp",
        link: "https://www.youtube.com/watch?v=ItRwkMDI8Qg"
      },
      {
        title: "one punch man lore video link",
        image: "/assets/anishorts/OPMlore.webp",
        link: "https://www.youtube.com/watch?v=NSWtFS4nwuA"
      },
      {
        title: "gurren lagann lore video link",
        image: "/assets/anishorts/TTGLlore.webp",
        link: "https://www.youtube.com/watch?v=erDrgWIJkbw&t=3s"
      },
      {
        title: "yu-gi-oh lore video link",
        image: "/assets/anishorts/YGOlore.webp",
        link: "https://www.youtube.com/watch?v=osfWvaRAuM4&t=16s"
      }
    ]
  }
];


export const education = [
  {
    listTitle: "university education",
    samples: [
      {
        institution: "University of California, San Diego",
        imgSrc: "/assets/eduicons/UCSDlogo.png",
        imgTitle: "UCSD logo",
        summary: "Department of Communication PhD Program",
        details: "Advisor: Dr. Erin Hill",
        link: "https://communication.ucsd.edu/",
      },
      {
        institution: "University of California, San Diego",
        imgSrc: "/assets/eduicons/UCSDlogo.png",
        imgTitle: "UCSD logo",
        summary: "Department of Communication",
        details: "M.A. in Communication",
        link: "https://communication.ucsd.edu/",
      },
      {
        institution: "Ithaca College",
        imgSrc: "/assets/eduicons/IClogo.jpg",
        imgTitle: "IC logo",
        summary: "Roy H. Park School of Communications",
        details: "B.S. Communications, Television / Radio Production",
        link: "https://www.ithaca.edu/academics/roy-h-park-school-communications",
      },
    ]
  },
  {
    listTitle: "creative education",
    samples: [
      {
        institution: "Upright Citizens Brigade",
        imgSrc: "/assets/eduicons/UCBlogo.jpg",
        imgTitle: "UCB logo",
        summary: "Sketch Writing 101 and 201",
        details: "Instructor: Neil Campbell",
        link: "https://ucbcomedy.com/",
      },
      {
        institution: "La Jolla Athenaeum",
        imgSrc: "/assets/eduicons/LJAlogo.png",
        imgTitle: "Athenaeum logo",
        summary: "Quick Sketch Life Drawing",
        details: "Instructor: Marty Davis",
        link: "https://www.ljathenaeum.org/art-classes",
      },
      {
        institution: "The Brainstorm School",
        imgSrc: "/assets/eduicons/LJAlogo.png",
        imgTitle: "Brainstorm logo",
        summary: "Storyboarding for Animation",
        details: "Instructor: Spencer Wan",
        link: "https://brainstormschool.com/",
      },
      {
        institution: "Smarter Art School",
        imgSrc: "/assets/eduicons/sas-logo.jpg",
        imgTitle: "Smarter Art School logo",
        summary: "Drawing Skills / Illustration",
        details: "Instructor: Eric Wilkerson",
        link: "https://www.smarterartschool.com/",
      },
      {
        institution: "Philip Sue Art",
        imgSrc: "/assets/eduicons/PSueArt.jpg",
        imgTitle: "Philip Sue Art logo",
        summary: "Environment Digital Painting",
        details: "Instructor: Philip Sue",
        link: "https://www.createwithphil.com/login",
      },
      {
        institution: "UCSD Extended Studies",
        imgSrc: "/assets/eduicons/UCSDXlogo.jpeg",
        imgTitle: "UCSD Extended Studies logo",
        summary: "Art and the Creative Process Certification",
        details: "Instructors: Kelsey Worth, Michelle McCunney",
        link: "https://extendedstudies.ucsd.edu/certificates/art-and-the-creative-process",
      },
      {
        institution: "Skillshare",
        imgSrc: "/assets/eduicons/Skillshare.webp",
        imgTitle: "Skillshare logo",
        summary: "Multiple Courses in Illustration, Painting, Animation, Design, etc.",
        details: "Instructors: Sandra Staub, Gabrielle Brickey, Gabriel Picolo, and many more",
        link: "https://www.skillshare.com/en/home",
      },
      {
        institution: "Feminist Comic Book Club of San Diego",
        imgSrc: "/assets/eduicons/FCBClogo.jpg",
        imgTitle: "FCBC logo",
        summary: "Weekly Creative Workshop (2016-present)",
        details: "Organizer: Michael Gainey",
        link: "",
      },
    ]
  },
  {
    listTitle: "software development",
    samples: [
      {
        institution: "Codeworks.me",
        imgSrc: "/assets/eduicons/CWlogo.png",
        imgTitle: "Codeworks logo",
        summary: "Software Development Immersive",
        details: "A competitive program with a 3% acceptance rate.",
        link: "https://codeworks.me/",
      },
      {
        institution: "AlgoExpert.io",
        imgSrc: "/assets/eduicons/AElogo.jpg",
        imgTitle: "AlgoExpert logo",
        summary: "FrontendExpert Certification",
        details: "ID: a35557c297",
        link: "https://www.algoexpert.io/frontend/product",
      },
      {
        institution: "Frontend Masters",
        imgSrc: "/assets/eduicons/FEMlogo.png",
        imgTitle: "Frontend Masters logo",
        summary: "Beginner & Pro Learning Paths",
        details: "Instructors: Brian Holt, Will Sentance, Jen Kramer",
        link: "https://frontendmasters.com/",
      },
      {
        institution: "Khan Academy",
        imgSrc: "/assets/eduicons/Khanlogo.png",
        imgTitle: "Khan Academy logo",
        summary: "Computer Programming",
        details: "JavaScript and the Web",
        link: "https://www.khanacademy.org/",
      },
      {
        institution: "Codecademy",
        imgSrc: "/assets/eduicons/CodeCademylogo.png",
        imgTitle: "Codecademy logo",
        summary: "Front-End Engineer Path",
        details: "Javascript, HTML, CSS, React, React Testing, Python, RegEx",
        link: "https://www.codecademy.com/learn",
      },
      {
        institution: "Codewars",
        imgSrc: "/assets/eduicons/CodeWarslogo.png",
        imgTitle: "Codewars logo",
        summary: "Javascript",
        details: "47 Honor, 23 Kata Completed",
        link: "https://www.codewars.com/",
      },
    ]
  },
  {
    listTitle: "miscellaneous",
    samples: [
      {
        institution: "Wild Willow Farm and Education Center",
        imgSrc: "/assets/eduicons/WWFEClogo.jpg",
        imgTitle: "Wild Willow Farm logo",
        summary: "Regenerative Farming 101 and 102",
        details: "Instructor: Paul Maschka",
        link: "https://www.wildwillowfarm.org/",
      },
    ]
  },
  {
    listTitle: "early career experience",
    samples: [
      {
        institution: "Maker Studios",
        imgSrc: "/assets/eduicons/MSlogo.jpeg",
        imgTitle: "Maker Studios logo",
        summary: "Writer and Editor",
        details: "Animation, Sketch, and Game writing for Lore in a Minute, Friendzone, Multiplayer, and more",
        link: "https://www.imdb.com/name/nm3377511/",
      },
      {
        institution: "Upper Deck Entertainment",
        imgSrc: "/assets/eduicons/UDlogo.png",
        imgTitle: "Upper Deck logo",
        summary: "Project Coordinator, Copy Editor, Game Tester",
        details: "Card and Game products for Marvel, Miramax, 20th Century Fox, James Bond, etc.",
        link: "https://www.imdb.com/name/nm3377511/",
      },
      {
        institution: "Pee-wee's Big Holiday",
        imgSrc: "/assets/eduicons/PWBHlogo.jpg",
        imgTitle: "Pee-wee logo",
        summary: "Assistant to Paul Reubens",
        details: "Pre-Production and Production of the Netflix film",
        link: "https://www.imdb.com/name/nm3377511/",
      },
      {
        institution: "Futurama",
        imgSrc: "/assets/eduicons/Futuramalogo.jpg",
        imgTitle: "Futurama logo",
        summary: "Writers Production Assistant",
        details: "The Emmy Winning Season 6",
        link: "https://www.imdb.com/name/nm3377511/",
      },
      {
        institution: "Fox Television Animation",
        imgSrc: "/assets/eduicons/FGlogo.png",
        imgTitle: "Family Guy logo",
        summary: "Assistant to Seth MacFarlane",
        details: "Family Guy, American Dad, The Cleveland Show, Ted, Seth and Alex's Almost Live Show, Cavalcade of Cartoon Comedy",
        link: "https://www.imdb.com/name/nm3377511/",
      },
      {
        institution: "The Ellen DeGeneres Show",
        imgSrc: "/assets/eduicons/Ellenlogo.jpg",
        imgTitle: "Ellen Degeneres logo",
        summary: "Production Assistant",
        details: "Season 5",
        link: "https://www.imdb.com/name/nm3377511/",
      },
      {
        institution: "Last Call with Carson Daly",
        imgSrc: "/assets/eduicons/LCCDlogo.png",
        imgTitle: "Last Call logo",
        summary: "Intern",
        details: "Talent Department",
        link: "https://www.imdb.com/name/nm3377511/",
      },
    ]
  },
];


export const teaching = [
  {
    listTitle: "lecturing",
    samples: [
      {
        institution: "University of California, San Diego",
        imgSrc: "/assets/eduicons/UCSDlogo.png",
        imgTitle: "UCSD logo",
        department: "Warren College Writing Program",
        details: "Lecturer and Departmental Tutor",
        courses: [
          "WCWP 10B: Disney Animation and Ideology",
          "WCWP 10A: Climate Change Ethics",
          "WCWP 10A: Promises and Contradictions in American History",
          "WCWP 10B: Justice in American History",
          "WCWP 10B: Food Ethics"
        ],
      },
      {
        institution: "University of California, San Diego",
        imgSrc: "/assets/eduicons/UCSDlogo.png",
        imgTitle: "UCSD logo",
        department: "Department of Communication",
        details: "Instructional Assistant",
        courses: [
          "Comm 10: Introduction to Communication"
        ],
      },
      {
        institution: "University of California, San Diego",
        imgSrc: "/assets/eduicons/UCSDlogo.png",
        imgTitle: "UCSD logo",
        department: "Department of Psychology",
        details: "Instructional Assistant",
        courses: [
          "Psych 7: General Psychology: Developmental Foundations "
        ],
      },
      {
        institution: "San Diego State University",
        imgSrc: "/assets/eduicons/SDSUlogo.jpg",
        imgTitle: "SDSU logo",
        department: "Television, Film, and New Media",
        details: "Guest Lecturer",
        courses: [
          "TFM 430: History of Television",
        ],
      },
      {
        institution: "La Jolla Country Day School",
        imgSrc: "/assets/eduicons/LJCDSlogo.png",
        imgTitle: "LJCDS logo",
        department: "Visual Arts Program",
        details: "Guest Lecturer",
        courses: [
          "The Upper School Film Course",
        ],
      },
    ]
  },
];